import Dashboard from './dashboard';
import Societe from './societe';
import Dictionnaire from './dictionnaire';
import User from './user-routes';

export default [...Dashboard, ...Societe, ...Dictionnaire, ...User];
